import React, { useState, useEffect } from "react";
import { Table } from "antd";

//import multilanguage library
import { useTranslation } from "react-i18next";

const RenderTable = (props) => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [rowSelection, setRowSelection] = useState(null);
  const [onClick, setOnClick] = useState(null);
  const [pagination, setPagination] = useState({});
  const [size, setSize] = useState("default");
  const [rowKey, setRowKey] = useState("key");

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    props.data && setData(props.data);
    props.columns && setColumns(props.columns);
    props.rowSelection && setRowSelection(props.rowSelection);
    props.onClick && setOnClick(props.onClick);
    props.pagination && setPagination(props.pagination);
    props.rowKey && setRowKey(props.rowKey);
    props.size && setSize(props.size);
  }, [props]);

  return (
    <Table
      bordered
      dataSource={data}
      columns={columns}
      rowSelection={rowSelection}
      pagination={pagination}
      rowKey={rowKey}
      size={size}
      bodyStyle={{ backgroundColor: "White" }}
      onRow={(element) => ({
        onClick: (e) => (onClick === undefined || onClick === null ? e.preventDefault() : onClick(element, e.target)), // Changue only of we have callback
      })}
      locale={{
        filterConfirm: t("button.filter.ok"),
        filterReset: t("button.filter.reset"),
        emptyText: t("table.body.is_empty"),
      }}
    />
  );
};

export default RenderTable;
